import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClientItem } from '../model/client-item';
import { BYPASS_JW_TOKEN } from './interceptor.service';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class ExternalService {
  products!:ClientItem[]
  
  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) { }

  getProducts(apikey:string, poliza:string, cliente:string, idcliente: string, certificate: string, dealerCode: string):Observable<any>{
    console.log("external common service")
    const options = {
      headers: new HttpHeaders({
        apikey: apikey,
        client: idcliente,
        certificate: certificate,
        dealerCode: dealerCode,
        policy: poliza
      })
    };
    const body = {
      NumeroPoliza:poliza,
      Organizacion:cliente,
      IdCliente: idcliente
    }
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/getProducts`,body,options);
    
  }

  getIpAddress():Observable<any>{
    return this.http.get("https://api.ipify.org/?format=json", {
      context: new HttpContext().set(BYPASS_JW_TOKEN, true)
    })
  }

  // logOut(Authorization:string, liverpoolSessionId:string):Observable<any>{
  //   const options = {
  //     headers: new HttpHeaders({
  //       Authorization: Authorization
  //       , liverpoolSessionId: liverpoolSessionId
  //     })
  //   };
  //   return this.http.post(`${environment.SOCKET_ENDPOINT}/api/logOut`,{},options); 
  // }
  logOut(){
    this.storageService.clearData()
    window.location.href = 'https://masgarantia.liverpool.com.mx/'
  }

}
